// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_scrollDivOuter__l2-Vl {
    /* height: calc(100% - 238px) !important;
    min-height: calc(100% - 238px) !important;
    max-height: calc(100% - 238px) !important */
}

.styles_scrollDivInside__nPdMx {
    height: calc(100% - 80px) !important;
    min-height: calc(100% - 80px) !important;
    max-height: calc(100% - 80px) !important
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FavContent/styles.module.css"],"names":[],"mappings":"AAAA;IACI;;+CAE2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC;AACJ","sourcesContent":[".scrollDivOuter {\n    /* height: calc(100% - 238px) !important;\n    min-height: calc(100% - 238px) !important;\n    max-height: calc(100% - 238px) !important */\n}\n\n.scrollDivInside {\n    height: calc(100% - 80px) !important;\n    min-height: calc(100% - 80px) !important;\n    max-height: calc(100% - 80px) !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollDivOuter": `styles_scrollDivOuter__l2-Vl`,
	"scrollDivInside": `styles_scrollDivInside__nPdMx`
};
export default ___CSS_LOADER_EXPORT___;
